/**
 * 调查问卷相关
 * 接口地址http://rap2.10niu.cn/organization/repository/editor?id=107&mod=569
 * 原型https://4y9coa.axshare.com/#g=1&p=%E9%97%AE%E5%8D%B7%E8%B0%83%E6%9F%A5_2
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
/* 
*调查问卷 
*/
const questionnaireSurvey = {
	// 获取问卷列表
	getSurveyList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/survey/v1/admin/survey_list`,
			headers: config.headers,
			params
		});
	},
	// 获取问卷提交明细
	getSurveyReceiverList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/survey/v1/admin/survey_receiver_list`,
			headers: config.headers,
			params
		});
	}
};

export default questionnaireSurvey;
